import axios from 'axios'
// const URL = 'http://localhost:8001'

export const send = async (loginUser) => {
    try {

        const email = loginUser.email
        const password = loginUser.password
        const apiURL = "https://apiaryfund.net/apiaryMigration/user-login?username=" + encodeURIComponent(email) + "&password=" + encodeURIComponent(password);
        return await axios.post(apiURL)

    } catch (error) {
        return error.response
    }

}

export const registerUser = async (userData) => {
    console.log('hye')
    // try {
    //     const data = {
    //         email: userData.email,
    //         password: userData.password,
    //         username: userData.username,
    //     }
    //     return await axios.post(`${URL}/register`, data)
    // } catch (error) {
    //     return error.response
    // }
}

export const getAllUsersAccountsData = async (dashminId) => {
    // const apiURL = "https://traderonthestreet.com/stats/server/api/user/accounts/" + dashminId
    // const response = await axios.get(apiURL)
    // console.log(response.data)
    // return response.data
}